import React, { useEffect, useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col } from "reactstrap";
import {
	Card,
	FormGroup,
	Alert,
	CardBody,
	CardTitle,
	CardFooter
} from "reactstrap";
import Box from "@mui/material/Box";
import GetAppIcon from "@mui/icons-material/GetApp";

import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import CardContent from "@mui/material/CardContent";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import SaveIcon from "@mui/icons-material/Save";
import ThumbUpAltRoundedIcon from "@mui/icons-material/ThumbUpAltRounded";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import { dealerApproveRejectDsrList } from "../../redux/actions/dealerApproveRejectDsrAction";
import success from "../../assets/img/success.png";
import SOLogout from "../../components/Logout/SOLogout";
import failed from "../../assets/img/failed.png";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {
	Grid,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	Button,
	Accordion,
	TextField,
	AccordionSummary,
	DialogTitle,
	Dialog,
	DialogActions,
	DialogContent,
	AccordionDetails
} from "@mui/material";
import Layout from "../../components/Wrappers/Layout";
import BackButton from "../../components/BackButton/BackButton";
import { dealerViewDsrList, resetDealerViewDsrList } from "../../redux/actions/dealerViewDsrListAction";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const DealerViewDsrList = () => {
	const location = useLocation();
	const [viewDsrDetailsStatus, setViewDsrDetailsStatus] = useState(false);

	const [viewDsrDetailsArray, setViewDsrDetailsArray] = useState("");
	const [getVerifyStatus, setGetVerifyStatus] = useState(false);

	const [getApprovedorRejectDsrStatus, setGetApprovedorRejectDsrStatus] =
		useState(false);

	const [setApproveRejectDsrArray, setSetApproveRejectDsrArray] = useState([]);
	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const [openBlockdsr, setOpenBlockDsr] = React.useState(false);
	const [getDescription, setGetDescription] = useState("");

	const [customerId, setCustomerId] = useState("");
	const [personId, setPersonId] = useState("");
	const [recommendation, setRecommendation] = useState("");
	const [description, setDescription] = useState("");
	const [role, setRole] = useState("");
	const [username, setUsername] = useState("");
	const [accStatus, setaccsstatus] = useState(false);
	const [rejectdisabled, setrejectdisabled] = useState(false);
	const [pendingapprove, setpendingapprove] = useState(false);
	const [pendingreject, setpendingreject] = useState(false);
	const [pendingRejectDisable, setPendingRejectDisable] = useState(false);



	const dispatch = useDispatch();
	const dealerId = location.state.param1;
	const custId = location.state.param2;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;

	const viewDsrDeatilsRes = useSelector(
		({ dealerViewDsrList }) => dealerViewDsrList
	);

	const getApproveRejectDsrRes = useSelector(
		({ dealerApproveRejectdsrLists }) => dealerApproveRejectdsrLists
	);

	// const [userData, setUserData] = useState({

	// })
	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	const handleClose = () => {
		// setOpen(false);
		setOpenBlockDsr(false);
	};
	const handleChange = ({ target: { name, value } }) => {
		if (name === "GetDescription") {
			setGetDescription(value);
		}
	};
	const ApproveRejectListFunc = () => {
		setOpenBlockDsr(true);
		// setpendingreject(true)
	};
	const handleAcceptOrRejectReq = (
		customerId,
		personId,
		recommendation,
		description,
		role
	) => {
		console.log(customerId, role, personId, description, recommendation);

		setGetApprovedorRejectDsrStatus(true);
		const approveOrRejectReq = {
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId || "",
				customerId: customerId,
				personId: personId,
				recommendation: recommendation,
				description: getDescription,
				role: "Dealer",
				userName: "testDealer"
			}
		};
		setOpenBlockDsr(false);
		// setGetVerifyStatus(true)

		return dispatch(dealerApproveRejectDsrList(approveOrRejectReq, authToken));
	};

	const getApproveRejectDsrFunc = () => {
		if (getApprovedorRejectDsrStatus) {
			// if (getApproveRejectDsrRes.data.status == "Approved") {
			//     setNotificationOpen(true);

			// }
			if (getApproveRejectDsrRes.data.status == "success") {
				setSetApproveRejectDsrArray(getApproveRejectDsrRes.data);
				setNotificationOpen(true);
			}
			if (getApproveRejectDsrRes.data.status == "failed") {
				setSetApproveRejectDsrArray(getApproveRejectDsrRes.data);
				setNotificationOpen(true);
				if (
					getApproveRejectDsrRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getApproveRejectDsrRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getApproveRejectDsrFunc();
	}, [getApproveRejectDsrRes.data.status]);

	// const getApproveRejectDsrReq = () => {
	//     setGetApprovedorRejectDsrStatus(true)
	//     const req = {
	//         actionCustomerMasterRequestVO: {
	//             dealerId: regenerateTokenRes.data.partnerId || "",
	//             dsrNumber: userMobNumber,
	//             dsrName: userName,
	//             dsrId: userId
	//         }
	//     }
	//     dispatch(dealerApproveRejectDsrList(req, authToken))
	// }

	const setViewDsrListStatusFunc = () => {
		setViewDsrDetailsStatus(true);
		let req = {
			// loginDetails: {
			//     walletOwnerId: regenerateTokenRes.data.partnerId || "",
			// },
			actionCustomerMasterRequestVO: {
				dealerId: regenerateTokenRes.data.partnerId || "",
				custId: dealerId
			}
		};

		return dispatch(dealerViewDsrList(req, authToken));
	};
	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			// dispatch(resetDealerViewDsrList());
			setViewDsrListStatusFunc();
		}
	}, [regenerateTokenRes.data.status]);

	const viewDsrListStatusFunc = () => {
		if (viewDsrDetailsStatus) {
			if (viewDsrDeatilsRes.data.status == "success") {
				setViewDsrDetailsArray(viewDsrDeatilsRes.data);
				// setViewKycDetailsArray(obj);
			}
			if (viewDsrDeatilsRes.data.status == "failed") {
				setViewDsrDetailsArray(viewDsrDeatilsRes.data);
				if (
					viewDsrDeatilsRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					viewDsrDeatilsRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};
	useEffect(() => {
		viewDsrListStatusFunc();
	}, [viewDsrDeatilsRes.data.status]);

	const approvestatus = () => {
		if (accStatus == "Approve") {
			setGetVerifyStatus(true);
		}
		return getVerifyStatus;
	};

	const rejectdisabledfunc = () => {
		if (accStatus == "Reject") {
			setGetVerifyStatus(true);
		}
		return getVerifyStatus;
	};
	useEffect(() => {
		setaccsstatus(
			viewDsrDetailsArray.kybDetailsList &&
				viewDsrDetailsArray.kybDetailsList.verifyStatus
				? viewDsrDetailsArray.kybDetailsList.verifyStatus
				: "-"
		);
		// console.log("Account Status: ", accStatus);
	});
	// useEffect(() => {
	// 	console.log(viewDsrDeatilsRes.data.userMaster, "/////////////////////////////////////////")
	// }, [viewDsrDeatilsRes])

	// console.log('viewDsrDetailsArray obj: ', viewDsrDetailsArray.userMaster.base64UserPhotoFront);
	// console.log("upload photo: ", viewDsrDetailsArray.userMaster)
	// console.log("dsrViewdata: ", viewDsrDetailsArray)



	// function decodeBase64(base64data){
	// 	let base64ToString = Buffer.from(base64data, "base64").toString()
	// 	this.setState({data: base64ToString })
	// }

	// render() {
	// 	return (
	// 	   <img src={"data:image/jpeg;base64," + this.state.data} />
	// 	)
	// }
	// function decodeBase64(base64data) {
	// 	let base64ToString = Buffer.from(base64data, "base64").toString()
	// 	useState({ data: base64ToString })
	// }

	return (
		<>
			<Layout>
				<BackButton />

				<div style={{ marginBottom: "1.5rem" }}>
					<Alert
						className="text-center themeBackground"
						variant="secondary"
						// fullWidth={true}
						style={{ borderRadius: "0" }}
					>
						<Typography variant="body1">DRS Details</Typography>
					</Alert>
				</div>
				<div
					style={{
						background: "white"
					}}
				>
					<Alert
						className="text-left themeBackground"
						variant="secondary"
						// fullWidth={true}
						style={{ backgroundColor: "#00b9f5", borderRadius: "0" }}
					>
						<Typography variant="body1">DRS Personal Details</Typography>
					</Alert>

					<Box marginLeft={3} marginRight={3} paddingBottom={2}>
						<div
							style={{
								marginTop: "2rem"
							}}
						>
							<Col md={12}>
								<Row className="detail-info row">
									<Col md={6}>DRS ID:</Col>
									<Col md={6}>
										{viewDsrDetailsArray.kybDetailsList &&
											viewDsrDetailsArray.kybDetailsList.customerId
											? viewDsrDetailsArray.kybDetailsList &&
											viewDsrDetailsArray.kybDetailsList.customerId
											: "-"}
										{/* {viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.custId ? viewDsrDetailsArray.kybDetailsList &&
                                        viewDsrDetailsArray.kybDetailsList.custId : "-"} */}

										{/* {viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.customerId &&
                                            []
                                                .concat(viewDsrDetailsArray.kybDetailsList.customerId)
                                                .map((detail, i) => {
                                                    return <Col md={4}>{detail}</Col>;
                                                }) ?
                                            viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.customerId &&
                                            []
                                                .concat(viewDsrDetailsArray.kybDetailsList.customerId)
                                                .map((detail, i) => {
                                                    return <Col md={4}>{detail}</Col>;
                                                }) : "-"} */}
									</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col md={6}>Person ID:</Col>
									<Col md={6}>
										{viewDsrDetailsArray.kybDetailsList &&
											viewDsrDetailsArray.kybDetailsList.personId
											? viewDsrDetailsArray.kybDetailsList &&
											viewDsrDetailsArray.kybDetailsList.personId
											: "-"}
									</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col md={6}>Verification status</Col>
									<Col md={6}>
										{viewDsrDetailsArray.kybDetailsList &&
											viewDsrDetailsArray.kybDetailsList.verifyStatus
											? viewDsrDetailsArray.kybDetailsList.verifyStatus
											: "-"}
										{/* {viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.verifyStatus &&
                                            []
                                                .concat(viewDsrDetailsArray.kybDetailsList.verifyStatus)
                                                .map((detail, i) => {
                                                    return <Col md={4}>{detail}</Col>;
                                                }) ?
                                            viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.verifyStatus &&
                                            []
                                                .concat(viewDsrDetailsArray.kybDetailsList.verifyStatus)
                                                .map((detail, i) => {
                                                    return <Col md={4}>{detail}</Col>;
                                                }) : "-"} */}
									</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col md={6}>Verification Description</Col>
									<Col md={6}>
										{viewDsrDetailsArray.customerMasterDetailsResponseVO &&
											viewDsrDetailsArray.customerMasterDetailsResponseVO
												.kybDetailsList &&
											[]
												.concat(
													viewDsrDetailsArray.customerMasterDetailsResponseVO
														.kybDetailsList
												)
												.map((detail, i) => {
													return <Col md={4}>{detail.description}</Col>;
												})
											? viewDsrDetailsArray.customerMasterDetailsResponseVO &&
											viewDsrDetailsArray.customerMasterDetailsResponseVO
												.kybDetailsList &&
											[]
												.concat(
													viewDsrDetailsArray.customerMasterDetailsResponseVO
														.kybDetailsList
												)
												.map((detail, i) => {
													return <Col md={4}>{detail.description}</Col>;
												})
											: "-"}
									</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col md={6}>Verification Type</Col>
									<Col md={6}>
										{viewDsrDetailsArray.kybDetailsList &&
											viewDsrDetailsArray.kybDetailsList.docCheckType
											? viewDsrDetailsArray.kybDetailsList.docCheckType
											: "-"}
										{/* {viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.docCheckType &&
                                            []
                                                .concat(viewDsrDetailsArray.kybDetailsList.docCheckType)
                                                .map((detail, i) => {
                                                    return <Col md={4}>{detail}</Col>;
                                                }) ?
                                            viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.docCheckType &&
                                            []
                                                .concat(viewDsrDetailsArray.kybDetailsList.docCheckType)
                                                .map((detail, i) => {
                                                    return <Col md={4}>{detail}</Col>;
                                                }) : "-"} */}
									</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col md={6}>Score</Col>
									<Col md={6}>
										{viewDsrDetailsArray.customerMasterDetailsResponseVO &&
											viewDsrDetailsArray.customerMasterDetailsResponseVO
												.kybDetailsList &&
											[]
												.concat(
													viewDsrDetailsArray.customerMasterDetailsResponseVO
														.kybDetailsList
												)
												.map((detail, i) => {
													return <Col md={4}>{detail.fraudScore}</Col>;
												})
											? viewDsrDetailsArray.customerMasterDetailsResponseVO &&
											viewDsrDetailsArray.customerMasterDetailsResponseVO
												.kybDetailsList &&
											[]
												.concat(
													viewDsrDetailsArray.customerMasterDetailsResponseVO
														.kybDetailsList
												)
												.map((detail, i) => {
													return <Col md={4}>{detail.fraudScore}</Col>;
												})
											: "-"}
									</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col md={6}>Recommendation</Col>
									<Col md={6}>
										{viewDsrDetailsArray.kybDetailsList &&
											viewDsrDetailsArray.kybDetailsList.recommendation
											? viewDsrDetailsArray.kybDetailsList.recommendation
											: "-"}
										{/* {viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.recommendation &&
                                            []
                                                .concat(viewDsrDetailsArray.kybDetailsList.recommendation)
                                                .map((detail, i) => {
                                                    return <Col md={4}>{detail}</Col>;
                                                }) ?
                                            viewDsrDetailsArray.kybDetailsList &&
                                            viewDsrDetailsArray.kybDetailsList.recommendation &&
                                            []
                                                .concat(viewDsrDetailsArray.kybDetailsList.recommendation)
                                                .map((detail, i) => {
                                                    return <Col md={4}>{detail}</Col>;
                                                }) : "-"} */}
									</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col md={6}>Full Name:</Col>
									<Col md={6}>
										{viewDsrDetailsArray.actionCustomerMasterResponseVO1 &&
											viewDsrDetailsArray.actionCustomerMasterResponseVO1
												.firstName
											? viewDsrDetailsArray.actionCustomerMasterResponseVO1 &&
											viewDsrDetailsArray.actionCustomerMasterResponseVO1
												.firstName
											: "-"}
									</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col md={6}>Father Name:</Col>
									<Col md={6}>
										{viewDsrDetailsArray.actionCustomerMasterResponseVO1 &&
											viewDsrDetailsArray.actionCustomerMasterResponseVO1
												.fatherName
											? viewDsrDetailsArray.actionCustomerMasterResponseVO1 &&
											viewDsrDetailsArray.actionCustomerMasterResponseVO1
												.fatherName
											: "-"}
									</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col md={6}>Mother Name:</Col>
									<Col md={6}>
										{viewDsrDetailsArray.actionCustomerMasterResponseVO1 &&
											viewDsrDetailsArray.actionCustomerMasterResponseVO1
												.motherName
											? viewDsrDetailsArray.actionCustomerMasterResponseVO1 &&
											viewDsrDetailsArray.actionCustomerMasterResponseVO1
												.motherName
											: "-"}
									</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col md={6}>Address:</Col>
									<Col md={6}>
										{viewDsrDetailsArray.actionCustomerMasterResponseVO1 &&
											viewDsrDetailsArray.actionCustomerMasterResponseVO1.address
											? viewDsrDetailsArray.actionCustomerMasterResponseVO1 &&
											viewDsrDetailsArray.actionCustomerMasterResponseVO1
												.address
											: "-"}
									</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col md={6}>Country:</Col>
									<Col md={6}>
										{viewDsrDetailsArray.actionCustomerMasterResponseVO1 &&
											viewDsrDetailsArray.actionCustomerMasterResponseVO1.country
											? viewDsrDetailsArray.actionCustomerMasterResponseVO1 &&
											viewDsrDetailsArray.actionCustomerMasterResponseVO1
												.country
											: "-"}
									</Col>
								</Row>

								<hr />
								<Row className="detail-info row">
									<Col md={6}>Division:</Col>
									<Col md={6}>
										{viewDsrDetailsArray.actionCustomerMasterResponseVO1 &&
											viewDsrDetailsArray.actionCustomerMasterResponseVO1.division
											? viewDsrDetailsArray.actionCustomerMasterResponseVO1 &&
											viewDsrDetailsArray.actionCustomerMasterResponseVO1
												.division
											: "-"}
									</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col md={6}>District:</Col>
									<Col md={6}>
										{viewDsrDetailsArray.actionCustomerMasterResponseVO1 &&
											viewDsrDetailsArray.actionCustomerMasterResponseVO1.district
											? viewDsrDetailsArray.actionCustomerMasterResponseVO1 &&
											viewDsrDetailsArray.actionCustomerMasterResponseVO1
												.district
											: "-"}
									</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col md={6}>Thana:</Col>
									<Col md={6}>
										{viewDsrDetailsArray.actionCustomerMasterResponseVO1 &&
											viewDsrDetailsArray.actionCustomerMasterResponseVO1.thana
											? viewDsrDetailsArray.actionCustomerMasterResponseVO1 &&
											viewDsrDetailsArray.actionCustomerMasterResponseVO1
												.thana
											: "-"}
									</Col>
								</Row>
								<hr />
								<Row className="detail-info row">
									<Col md={6}>Union:</Col>
									<Col md={6}>
										{viewDsrDetailsArray.actionCustomerMasterResponseVO1 &&
											viewDsrDetailsArray.actionCustomerMasterResponseVO1.union
											? viewDsrDetailsArray.actionCustomerMasterResponseVO1 &&
											viewDsrDetailsArray.actionCustomerMasterResponseVO1
												.union
											: "-"}
									</Col>
								</Row>
							</Col>
						</div>
					</Box>
				</div>



				{viewDsrDeatilsRes && viewDsrDeatilsRes.data && viewDsrDeatilsRes.data.userMaster && viewDsrDeatilsRes.data.userMaster.base64UserPhotoFront
					? (
						<div
							style={{
								background: "white"
							}}
						>
							<Alert
								className="text-left themeBackground"
								variant="secondary"
								// fullWidth={true}
								style={{ backgroundColor: "#00b9f5", borderRadius: "0" }}
							>
								<Typography variant="body1">Documents Details</Typography>
							</Alert>
							<Box marginLeft={3} marginRight={3} paddingBottom={2}>
								<div style={{ marginTop: "2rem" }}>


									<Row
										className="detail-info row"
										style={{ marginBottom: "2rem" }}
									>
										<Col sm={12} md={5}>
											{viewDsrDeatilsRes && viewDsrDeatilsRes.data && viewDsrDeatilsRes.data.userMaster && viewDsrDeatilsRes.data.userMaster.base64UserPhotoFront && <Card >
												<CardTitle>
													<h6>Front Pic</h6>

												</CardTitle>
												<CardBody>
													<img
														src={`data:image/jpeg;base64,${viewDsrDeatilsRes.data.userMaster.base64UserPhotoFront}`}
														style={{ maxWidth: "100%" }}
													/>
													<br />
													<br />
													<h6 style={{ display: "inline" }}>
														{viewDsrDeatilsRes.data.userMaster.userPhotoIdFileName}
													</h6>
													<a
														download={viewDsrDeatilsRes.data.userMaster.userPhotoIdFileName}
														href={`data:image/jpeg;base64,${viewDsrDeatilsRes.data.userMaster.base64UserPhotoFront}`}
													>
														<GetAppIcon />
													</a>
												</CardBody>
											</Card>}
										</Col>

										<Col sm={12} md={5}>
											{viewDsrDeatilsRes && viewDsrDeatilsRes.data && viewDsrDeatilsRes.data.userMaster && viewDsrDeatilsRes.data.userMaster.base64UserPhotoBack && <Card >
												<CardTitle>
													<h6>Back Pic</h6>

												</CardTitle>
												<CardBody>
													<img
														src={`data:image/jpeg;base64,${viewDsrDeatilsRes.data.userMaster.base64UserPhotoBack}`}
														style={{ maxWidth: "100%" }}
													/>
													<br />
													<br />
													<h6 style={{ display: "inline" }}>
														{viewDsrDeatilsRes.data.userMaster.userPhotoIdBackFileName}
													</h6>
													<a
														download={viewDsrDeatilsRes.data.userMaster.userPhotoIdBackFileName}
														href={`data:image/jpeg;base64,${viewDsrDeatilsRes.data.userMaster.base64UserPhotoBack}`}
													>
														<GetAppIcon />
													</a>
												</CardBody>
											</Card>}
										</Col>



									</Row>


								</div>
							</Box>
						</div>
					) : (
						""
					)

				}

				{/* <Row>
					<Col sm={12} md={6}>
						<Card>
							<CardTitle>
								<h6>127_National_ID_front.png</h6>
								<hr />
							</CardTitle>
							<CardBody>img</CardBody>
						</Card>
					</Col>
					<Col sm={12} md={6}>
						<Card>
							<CardTitle>
								<h6>127_National_ID_front.png</h6>
								<hr />
							</CardTitle>
							<CardBody>img</CardBody>
						</Card>
					</Col>
					<Col sm={12} md={12}>
						<Card>
							<CardTitle>
								<h6>127_National_ID_front.png</h6>
								<hr />
							</CardTitle>
							<CardBody>img</CardBody>
						</Card>
					</Col>
				</Row> */}

				<div className="text-center" style={{ marginTop: "2.5rem" }}>
					{ }

					{accStatus == "Pending" && (
						<>
							<CustomButton
								style={{
									padding: "8px",
									margin: "0 8px"
								}}
								disabled={pendingapprove}
								// color="primary"

								// onClick={handleAcceptOrRejectReq}
								onClick={() => {
									handleAcceptOrRejectReq(
										viewDsrDetailsArray.kybDetailsList.customerId,
										viewDsrDetailsArray.kybDetailsList.personId,
										"Approve"
									);
									setpendingapprove(true);
									setpendingreject(true);
									// setrejectdisabled(true);
								}}
							>
								Approve
								<ThumbUpAltRoundedIcon
									style={{ marginLeft: "4px", fontSize: "21px" }}
								/>
							</CustomButton>
							<CustomButton
								style={{
									padding: "8px",
									margin: "0 8px"
								}}
								variant="contained"
								// color="primary"
								onClick={ApproveRejectListFunc}
								disabled={pendingreject}
							>
								Reject
								<ClearRoundedIcon
									style={{ marginLeft: "4px", fontSize: "21px" }}
								/>
							</CustomButton>
						</>
					)}
					{accStatus == "Approve" && (
						<>
							<CustomButton
								style={{
									padding: "8px",
									margin: "0 8px"
								}}
								disabled={approvestatus}
								// color="primary"

								// onClick={handleAcceptOrRejectReq}
								onClick={() => {
									handleAcceptOrRejectReq(
										viewDsrDetailsArray.kybDetailsList.customerId,
										viewDsrDetailsArray.kybDetailsList.personId,
										"Approve"
									);
									setGetVerifyStatus(true);
									setPendingRejectDisable(true);
								}}
							>
								Approve
								<ThumbUpAltRoundedIcon
									style={{ marginLeft: "4px", fontSize: "21px" }}
								/>
							</CustomButton>
							<CustomButton
								style={{
									padding: "8px",
									margin: "0 8px"
								}}
								variant="contained"
								// color="primary"
								onClick={ApproveRejectListFunc}
								disabled={approvestatus}
							>
								Reject
								<ClearRoundedIcon
									style={{ marginLeft: "4px", fontSize: "21px" }}
								/>
							</CustomButton>
						</>
					)}

					{accStatus == "Reject" && (
						<>
							<CustomButton
								style={{
									padding: "8px",
									margin: "0 8px"
								}}
								disabled={true}
								// color="primary"

								onClick={handleAcceptOrRejectReq}
							>
								Approve
								<ThumbUpAltRoundedIcon
									style={{ marginLeft: "4px", fontSize: "21px" }}
								/>
							</CustomButton>
							<CustomButton
								style={{
									padding: "8px",
									margin: "0 8px"
								}}
								disabled={rejectdisabledfunc}
								variant="contained"
							// color="primary"
							// onClick={ApproveRejectListFunc}
							>
								Reject
								<ClearRoundedIcon
									style={{ marginLeft: "4px", fontSize: "21px" }}
								/>
							</CustomButton>
						</>
					)}
				</div>

				<div>
					<Dialog open={openBlockdsr} onClose={handleClose}>
						{/* <DialogTitle>Reject Document</DialogTitle>
                        
                        <hr /> */}
						{/* <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton> */}
						<DialogTitle style={{ width: "400px" }}>
							Are you sure you want to reject the document?
						</DialogTitle>
						<DialogActions className="p-3">
							<Grid item xs={12} md={12} lg={12}>
								<div style={{ marginTop: "1.5rem" }}>
									<TextField
										required
										type="text"
										size="small"
										color="primary"
										autoFocus={true}
										label="Reject Reason"
										fullWidth={true}
										name="GetDescription"
										value={getDescription || ""}
										onChange={handleChange}
									/>
								</div>
								<div className="text-right" style={{ marginTop: "2.5rem" }}>
									<CustomButton
										style={{
											padding: "8px",
											margin: "0 8px"
										}}
										variant="contained"
										// color="primary"
										onClick={() => {
											handleAcceptOrRejectReq(
												viewDsrDetailsArray.kybDetailsList.customerId,
												viewDsrDetailsArray.kybDetailsList.personId,
												"Reject"
											);
											setrejectdisabled(true);
											setpendingreject(true);
											setpendingapprove(true);
										}}
									>
										OK
									</CustomButton>
								</div>
							</Grid>
							{/* <TextField
                                size="small"
                                color="primary"
                                type="text"
                                label="Reject Reason"
                                fullWidth={true}
                                name="description"
                            // value={userMobNumber}
                            // onChange={onInputChange}
                            // onChange={(e) => onInputChange(e, "number")}
                            ></TextField> */}
							{/* 
                            <CustomButton
                                style={{
                                    // backgroundColor: "#00b9f5",
                                    color: "white",
                                }}
                                variant="contained"
                            // onClick={blockDsrMasterRecords}
                            >
                                Yes
                            </CustomButton> */}
						</DialogActions>
					</Dialog>
				</div>
			</Layout>

			{setApproveRejectDsrArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center lightThemeBackground"
							style={{}}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{setApproveRejectDsrArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									margin: "10px 0",
									// backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{setApproveRejectDsrArray.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center lightThemeBackground"
							style={{}}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{setApproveRejectDsrArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									margin: "10px 0",
									// backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
			{setApproveRejectDsrArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center lightThemeBackground"
							style={{}}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{setApproveRejectDsrArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									margin: "10px 0",
									// backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{setApproveRejectDsrArray.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center lightThemeBackground"
							style={{}}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{setApproveRejectDsrArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									margin: "10px 0",
									// backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default DealerViewDsrList;
